import { render, staticRenderFns } from "./TheForgotPassword.vue?vue&type=template&id=30f95364&scoped=true"
import script from "./TheForgotPassword.vue?vue&type=script&lang=js"
export * from "./TheForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./TheForgotPassword.vue?vue&type=style&index=0&id=30f95364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f95364",
  null
  
)

export default component.exports